import { styledWithInvalidProps } from "@components/Styled/StyledWithInvalidProps";
import React from "react";
import { SwiperOptions } from "swiper";
import { Swiper as SwiperReact } from "swiper/react";
import tw from "twin.macro";

export const generateSlideCssForBreakpoints = ({
  slidesPerView,
  spaceBetween,
  breakpoints,
  direction,
}: SwiperOptions) => {
  const defaultCss = `
    width: ${100 / slidesPerView}%;
    margin-right: ${spaceBetween}px;
  `;

  const spaceToReduce = (slidesPerView - 1 * spaceBetween - 1) / slidesPerView;

  const breakpointCss = breakpoints
    ? Object.keys(breakpoints).map((key) => {
        const breakpoint = breakpoints[key];
        const { slidesPerView, spaceBetween } = breakpoint || {};
        const width = isNaN(slidesPerView) ? 100 : 100 / slidesPerView;
        const margin = spaceBetween + spaceToReduce;

        return `
          @media only screen and (min-width: ${key}px) {
            width: calc(${width}% - ${margin}px);
            ${["horizontal", undefined].includes(direction) ? `margin-right: ${spaceBetween}px` : `margin-bottom: ${spaceBetween}px`};
          }
        `;
      })
    : [];

  return [defaultCss, ...breakpointCss].join("\n");
};

const Container = styledWithInvalidProps("div")(
  ({ slidesPerView, spaceBetween, direction, breakpoints }: SwiperOptions) => [
    tw`w-full`,
    `& .swiper-slide {
    ${generateSlideCssForBreakpoints({ slidesPerView, spaceBetween, breakpoints, direction })}
  }`,
  ],
);

const SwiperWrapper = (props: SwiperOptions) => (
  <Container {...props}>
    <SwiperReact {...props} />
  </Container>
);

export default SwiperWrapper;
